export const LIA_SAFEGUARD_OPTIONS = [
  'transparency',
  'right_to_object_or_opt_out',
  'data_minimisation',
  'limited_retention',
  'access_restriction',
  'pseudonymisation',
  'human_review',
  'other',
] as const;

export const LIA_CONCLUSION_OPTIONS = [
  'legitimate_interest_supported',
  'legitimate_interest_supported_with_safeguards',
  'legitimate_interest_not_supported',
] as const;

export const LIA_VALIDATION_STATUS_OPTIONS = ['valid', 'invalid'] as const;

export const MOCK_LIA_PURPOSE_ID = 301;
